// import { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import api from "../constant/api";
// import {
//   ArrowLeft, Shirt, Package, IndianRupee, Upload, X, Plus, Barcode,
//   Layers, Palette, Ruler, Tag, Building2, Truck, RefreshCw
// } from "lucide-react";

// const initialForm = {
//   product_name: "", description: "", price: "", mrp: "", qty: "",
//   pic: "", product_category: "", brand: "", size: "", color: "",
//   gender: "", fabric: "", pattern: "", unit: "pcs", branch: "",
//   supplier_id: "", hsn: ""
// };

// const categories = ["Shirt", "T-Shirt", "Jeans", "Trousers", "Saree", "Kurti", "Dress", "Kids Wear", "Innerwear", "Jacket", "Leggings", "Shorts", "Accessories", "Other"];
// const sizes = ["XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "Free Size", "28", "30", "32", "34", "36", "38", "40", "42", "44"];
// const colors = ["Black", "White", "Blue", "Navy Blue", "Red", "Green", "Grey", "Pink", "Yellow", "Brown", "Beige", "Purple", "Orange", "Multicolor", "Other"];
// const fabrics = ["Cotton", "Polyester", "Denim", "Linen", "Silk", "Rayon", "Wool", "Georgette", "Chiffon", "Viscose", "Blended", "Other"];
// const patterns = ["Plain", "Printed", "Striped", "Checked", "Embroidered", "Floral", "Graphic", "Self Design", "Other"];
// const genders = ["Men", "Women", "Unisex", "Boys", "Girls", "Kids"];
// const branches = ["A K Ceramic World", "A K Tiles Park", "A K Tiles Park Green", "A K Tiles Park Main road", "A K Tiles Park show room"];

// export default function GarmentsProduct() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState(initialForm);
//   const [suppliers, setSuppliers] = useState([]);
//   const [images, setImages] = useState([]);
//   const [previews, setPreviews] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     let active = true;
//     api.get("/Product/getSuppliers")
//       .then((res) => {
//         const data = res?.data?.data ?? res?.data ?? [];
//         if (active) setSuppliers(Array.isArray(data) ? data : []);
//       })
//       .catch((err) => console.error("Supplier load failed:", err));
//     return () => { active = false; };
//   }, []);

//   useEffect(() => () => previews.forEach((url) => URL.revokeObjectURL(url)), [previews]);

//   const setField = (name, value) => {
//     setForm((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const addFiles = (fileList) => {
//     const picked = Array.from(fileList || []);
//     const accepted = [];
//     let message = "";
//     picked.forEach((file) => {
//       if (!file.type.startsWith("image/")) message = "Only image files are allowed.";
//       else if (file.size > 2 * 1024 * 1024) message = "Each image must be 2 MB or smaller.";
//       else if (images.length + accepted.length >= 10) message = "Maximum 10 images allowed.";
//       else accepted.push(file);
//     });
//     if (message) setErrors((prev) => ({ ...prev, images: message }));
//     if (accepted.length) {
//       setImages((prev) => [...prev, ...accepted]);
//       setPreviews((prev) => [...prev, ...accepted.map((file) => URL.createObjectURL(file))]);
//     }
//   };

//   const removeImage = (index) => {
//     URL.revokeObjectURL(previews[index]);
//     setImages((prev) => prev.filter((_, i) => i !== index));
//     setPreviews((prev) => prev.filter((_, i) => i !== index));
//   };

//   const validate = () => {
//     const next = {};
//     if (!form.product_name.trim()) next.product_name = "Product name is required.";
//     if (!form.product_category) next.product_category = "Select a category.";
//     if (form.price === "" || !Number.isFinite(Number(form.price)) || Number(form.price) < 0) next.price = "Enter a valid selling price.";
//     if (form.mrp !== "" && (!Number.isFinite(Number(form.mrp)) || Number(form.mrp) < 0)) next.mrp = "Enter a valid MRP.";
//     if (form.qty === "" || !Number.isFinite(Number(form.qty)) || Number(form.qty) < 0) next.qty = "Enter a valid stock quantity.";
//     if (form.price !== "" && form.mrp !== "" && Number(form.mrp) < Number(form.price)) next.mrp = "MRP should be equal to or greater than selling price.";
//     setErrors(next);
//     return Object.keys(next).length === 0;
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!validate()) return;
//     const body = new FormData();
//     Object.entries(form).forEach(([key, value]) => body.append(key, value ?? ""));
//     images.forEach((file) => body.append("images", file));
//     setLoading(true);
//     try {
//       const res = await api.post("/Garments/insertProduct", body);
//       if (res?.data?.success === false) throw new Error(res.data.message || "Product could not be saved.");
//       toast.success(res?.data?.message || "Garments product added successfully");
//       setForm(initialForm);
//       setImages([]);
//       previews.forEach((url) => URL.revokeObjectURL(url));
//       setPreviews([]);
//       setErrors({});
//       navigate("/GarmentsProducts");
//     } catch (error) {
//       console.error("Garments product save failed:", error);
//       toast.error(error?.response?.data?.message || error.message || "Failed to add product");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const Field = ({ label, name, children, required = false, error }) => (
//     <div className="min-w-0">
//       <label htmlFor={name} className="mb-1.5 block text-sm font-semibold text-slate-700">{label}{required && <span className="text-rose-500"> *</span>}</label>
//       {children}
//       {error && <p className="mt-1 text-xs text-rose-600">{error}</p>}
//     </div>
//   );
//   const inputClass = "w-full rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-violet-500 focus:ring-4 focus:ring-violet-100";
//   const selectClass = inputClass;
//   const Select = ({ name, options, placeholder }) => (
//     <select id={name} name={name} value={form[name]} onChange={(e) => setField(name, e.target.value)} className={selectClass}>
//       <option value="">{placeholder}</option>
//       {options.map((option) => <option key={option} value={option}>{option}</option>)}
//     </select>
//   );
//   const supplierOptions = useMemo(() => suppliers.map((s) => ({ id: s.supplier_id, name: s.supplier_name })), [suppliers]);

//   return (
//     <div className="min-h-screen bg-slate-50 px-3 py-5 sm:px-6 lg:px-8">
//       {loading && <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 p-4"><div className="rounded-2xl bg-white px-8 py-6 text-center shadow-2xl"><RefreshCw className="mx-auto mb-3 h-8 w-8 animate-spin text-violet-600"/><p className="font-semibold text-slate-800">Saving garments product…</p><p className="mt-1 text-sm text-slate-500">Please do not close this page.</p></div></div>}
//       <div className="mx-auto max-w-6xl">
//         <button type="button" onClick={() => navigate(-1)} className="mb-4 inline-flex items-center gap-2 rounded-lg px-2 py-2 text-sm font-semibold text-slate-600 hover:bg-white hover:text-violet-700"><ArrowLeft size={18}/> Back</button>
//         <div className="mb-6 overflow-hidden rounded-2xl bg-gradient-to-r from-violet-700 via-purple-700 to-fuchsia-700 p-5 text-white shadow-lg sm:p-7">
//           <div className="flex items-center gap-4"><div className="rounded-2xl bg-white/15 p-3"><Shirt size={30}/></div><div><p className="text-sm font-medium text-violet-100">INVENTORY MANAGEMENT</p><h1 className="mt-1 text-2xl font-bold sm:text-3xl">Add Garments Product</h1><p className="mt-1 text-sm text-violet-100">Manage apparel, sizes, colours, pricing and stock.</p></div></div>
//         </div>
//         <form onSubmit={handleSubmit} className="space-y-5">
//           <section className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-6">
//             <div className="mb-5 flex items-center gap-3"><div className="rounded-xl bg-violet-100 p-2.5 text-violet-700"><Tag size={20}/></div><div><h2 className="font-bold text-slate-900">Product details</h2><p className="text-xs text-slate-500">Name, category and product attributes</p></div></div>
//             <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
//               <Field label="Product Name" name="product_name" required error={errors.product_name}><input id="product_name" className={inputClass} value={form.product_name} onChange={(e) => setField("product_name", e.target.value)} placeholder="e.g. Men's Cotton Shirt" /></Field>
//               <Field label="Category" name="product_category" required error={errors.product_category}><Select name="product_category" options={categories} placeholder="Select category"/></Field>
//               <Field label="Brand" name="brand"><input id="brand" className={inputClass} value={form.brand} onChange={(e) => setField("brand", e.target.value)} placeholder="Enter brand" /></Field>
//               <Field label="Gender" name="gender"><Select name="gender" options={genders} placeholder="Select gender"/></Field>
//               <Field label="Size" name="size"><Select name="size" options={sizes} placeholder="Select size"/></Field>
//               <Field label="Colour" name="color"><Select name="color" options={colors} placeholder="Select colour"/></Field>
//               <Field label="Fabric" name="fabric"><Select name="fabric" options={fabrics} placeholder="Select fabric"/></Field>
//               <Field label="Pattern" name="pattern"><Select name="pattern" options={patterns} placeholder="Select pattern"/></Field>
//               <Field label="Unit" name="unit"><Select name="unit" options={["pcs", "pair", "set"]} placeholder="Select unit"/></Field>
//             </div>
//             <div className="mt-4"><Field label="Description" name="description"><textarea id="description" rows={3} className={inputClass} value={form.description} onChange={(e) => setField("description", e.target.value)} placeholder="Material details, fit, care instructions, etc." /></Field></div>
//           </section>
//           <section className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-6">
//             <div className="mb-5 flex items-center gap-3"><div className="rounded-xl bg-emerald-100 p-2.5 text-emerald-700"><IndianRupee size={20}/></div><div><h2 className="font-bold text-slate-900">Pricing & stock</h2><p className="text-xs text-slate-500">Selling price, MRP and available quantity</p></div></div>
//             <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
//               <Field label="Selling Price (₹)" name="price" required error={errors.price}><input id="price" type="number" min="0" step="0.01" className={inputClass} value={form.price} onChange={(e) => setField("price", e.target.value)} placeholder="0.00" /></Field>
//               <Field label="MRP (₹)" name="mrp" error={errors.mrp}><input id="mrp" type="number" min="0" step="0.01" className={inputClass} value={form.mrp} onChange={(e) => setField("mrp", e.target.value)} placeholder="0.00" /></Field>
//               <Field label="Stock Quantity" name="qty" required error={errors.qty}><input id="qty" type="number" min="0" step="1" className={inputClass} value={form.qty} onChange={(e) => setField("qty", e.target.value)} placeholder="Available pieces" /></Field>
//               <Field label="HSN Code" name="hsn"><input id="hsn" inputMode="numeric" className={inputClass} value={form.hsn} onChange={(e) => setField("hsn", e.target.value)} placeholder="Enter HSN code" /></Field>
//               <Field label="Branch" name="branch"><select id="branch" className={selectClass} value={form.branch} onChange={(e) => setField("branch", e.target.value)}><option value="">Select branch</option>{branches.map((b) => <option key={b} value={b}>{b}</option>)}</select></Field>
//               <Field label="Supplier" name="supplier_id"><select id="supplier_id" className={selectClass} value={form.supplier_id} onChange={(e) => setField("supplier_id", e.target.value)}><option value="">Select supplier</option>{supplierOptions.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select></Field>
//               <Field label="Legacy PIC field (optional)" name="pic"><input id="pic" className={inputClass} value={form.pic} onChange={(e) => setField("pic", e.target.value)} placeholder="Optional reference" /></Field>
//             </div>
//           </section>
//           <section className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm sm:p-6">
//             <div className="mb-4 flex items-center gap-3"><div className="rounded-xl bg-sky-100 p-2.5 text-sky-700"><Upload size={20}/></div><div><h2 className="font-bold text-slate-900">Product images</h2><p className="text-xs text-slate-500">Up to 10 images, 2 MB per image</p></div></div>
//             <label onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); addFiles(e.dataTransfer.files); }} className="flex cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed border-violet-200 bg-violet-50/60 px-4 py-8 text-center transition hover:border-violet-400 hover:bg-violet-50">
//               <div className="mb-3 rounded-full bg-white p-3 text-violet-700 shadow-sm"><Upload size={22}/></div><span className="font-semibold text-slate-800">Click to upload or drag images here</span><span className="mt-1 text-xs text-slate-500">PNG, JPG, WEBP · Maximum 10 images</span>
//               <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => { addFiles(e.target.files); e.target.value = ""; }}/>
//             </label>
//             {errors.images && <p className="mt-2 text-sm text-rose-600">{errors.images}</p>}
//             {previews.length > 0 && <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-5">{previews.map((src, i) => <div key={src} className="group relative overflow-hidden rounded-xl border border-slate-200"><img src={src} alt={`Product preview ${i + 1}`} className="h-32 w-full object-cover"/><span className="absolute bottom-2 left-2 rounded-md bg-black/60 px-2 py-1 text-xs text-white">{i === 0 ? "Primary image" : `Image ${i + 1}`}</span><button type="button" onClick={() => removeImage(i)} className="absolute right-2 top-2 rounded-full bg-white/95 p-1.5 text-rose-600 shadow hover:bg-rose-50" aria-label="Remove image"><X size={16}/></button></div>)}</div>}
//           </section>
//           <div className="sticky bottom-0 z-10 -mx-3 flex gap-3 border-t border-slate-200 bg-white/95 p-3 backdrop-blur sm:static sm:mx-0 sm:justify-end sm:border-0 sm:bg-transparent sm:p-0">
//             <button type="button" disabled={loading} onClick={() => navigate(-1)} className="flex-1 rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 sm:flex-none">Cancel</button>
//             <button type="submit" disabled={loading} className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-violet-700 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-violet-200 transition hover:bg-violet-800 disabled:cursor-not-allowed disabled:opacity-60 sm:flex-none"><Plus size={18}/>{loading ? "Saving…" : "Save Garments Product"}</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Plus,
  Trash2,
  Upload,
  X,
  Package,
  Shirt,
  IndianRupee,
  Barcode,
  Save,
  LoaderCircle,
  ImagePlus,
  RefreshCw,
  Layers,
  CheckCircle2,
} from "lucide-react";
import { toast } from "react-toastify";
import api from "../constant/api";

const INITIAL_FORM = {
  product_name: "",
  description: "",
  product_category: "Shirts",
  brand: "",
  gender: "Unisex",
  fabric: "",
  pattern: "Solid",
  price: "",
  mrp: "",
  unit: "pcs",
  branch: "",
  supplier_id: "",
  hsn: "",
};

const INITIAL_VARIANT = {
  size: "M",
  color: "Black",
  qty: "0",
  sku: "",
};

const SIZES = [
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "XXXL",
  "Free Size",
  "28",
  "30",
  "32",
  "34",
  "36",
  "38",
  "40",
  "42",
  "44",
];

const COLORS = [
  "Black",
  "White",
  "Red",
  "Blue",
  "Navy Blue",
  "Green",
  "Yellow",
  "Pink",
  "Grey",
  "Brown",
  "Beige",
  "Maroon",
  "Orange",
  "Purple",
  "Multicolor",
  "Other",
];

const CATEGORIES = [
  "Shirts",
  "T-Shirts",
  "Jeans",
  "Trousers",
  "Pants",
  "Kurtis",
  "Sarees",
  "Dresses",
  "Kids Wear",
  "Innerwear",
  "Jackets",
  "Ethnic Wear",
  "Sports Wear",
  "Uniforms",
  "Accessories",
  "General",
];

const FABRICS = [
  "Cotton",
  "Polyester",
  "Linen",
  "Denim",
  "Silk",
  "Rayon",
  "Wool",
  "Cotton Blend",
  "Viscose",
  "Other",
];

const PATTERNS = [
  "Solid",
  "Printed",
  "Striped",
  "Checked",
  "Floral",
  "Plain",
  "Embroidered",
  "Graphic",
  "Other",
];

const GENDERS = ["Men", "Women", "Unisex", "Boys", "Girls", "Kids"];

const inputClass =
  "mt-1.5 w-full rounded-xl border border-slate-200 bg-white px-3.5 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100";

const labelClass = "text-sm font-semibold text-slate-700";

const cardClass =
  "rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6";

function Field({ label, required, children, className = "" }) {
  return (
    <div className={className}>
      <label className={labelClass}>
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>
      {children}
    </div>
  );
}

function SectionTitle({ icon: Icon, title, description }) {
  return (
    <div className="mb-5 flex items-start gap-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
        <Icon size={20} />
      </div>
      <div>
        <h2 className="text-base font-bold text-slate-900 sm:text-lg">
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-xs leading-5 text-slate-500 sm:text-sm">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}

export default function GarmentsProduct() {
  const navigate = useNavigate();

  const [form, setForm] = useState(INITIAL_FORM);
  const [variants, setVariants] = useState([{ ...INITIAL_VARIANT }]);
  const [images, setImages] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const imagePreviews = useMemo(
    () =>
      images.map((file) => ({
        file,
        url: URL.createObjectURL(file),
      })),
    [images]
  );

  useEffect(() => {
    return () => {
      imagePreviews.forEach((item) => URL.revokeObjectURL(item.url));
    };
  }, [imagePreviews]);

  useEffect(() => {
    loadSuppliers();
  }, []);

  const loadSuppliers = async () => {
    setLoadingSuppliers(true);

    try {
      const response = await api.get("/Product/getSuppliers");
      const payload = response.data;

      const list = Array.isArray(payload)
        ? payload
        : payload?.data || payload?.suppliers || [];

      setSuppliers(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error("Load suppliers error:", error);
      setSuppliers([]);
      toast.error("Supplier list could not be loaded");
    } finally {
      setLoadingSuppliers(false);
    }
  };

  const updateForm = (field, value) => {
    setForm((previous) => ({ ...previous, [field]: value }));

    setErrors((previous) => ({
      ...previous,
      [field]: "",
    }));
  };

  const updateVariant = (index, field, value) => {
    setVariants((previous) =>
      previous.map((variant, currentIndex) =>
        currentIndex === index
          ? { ...variant, [field]: value }
          : variant
      )
    );

    setErrors((previous) => ({ ...previous, variants: "" }));
  };

  const addVariant = () => {
    setVariants((previous) => [
      ...previous,
      {
        size: "L",
        color: "Black",
        qty: "0",
        sku: "",
      },
    ]);
  };

  const removeVariant = (index) => {
    if (variants.length === 1) {
      toast.warning("At least one size and color variant is required");
      return;
    }

    setVariants((previous) =>
      previous.filter((_, currentIndex) => currentIndex !== index)
    );
  };

  const handleImages = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    event.target.value = "";

    if (!selectedFiles.length) return;

    const availableSlots = 10 - images.length;

    if (availableSlots <= 0) {
      toast.warning("Maximum 10 images are allowed");
      return;
    }

    const validFiles = [];
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/webp",
      "image/gif",
    ];

    for (const file of selectedFiles) {
      if (!allowedTypes.includes(file.type)) {
        toast.error(`${file.name}: JPG, PNG, WEBP or GIF only`);
        continue;
      }

      if (file.size > 5 * 1024 * 1024) {
        toast.error(`${file.name}: Image must be below 5 MB`);
        continue;
      }

      validFiles.push(file);
    }

    const combined = [...images, ...validFiles].slice(0, 10);
    setImages(combined);
  };

  const removeImage = (index) => {
    setImages((previous) =>
      previous.filter((_, currentIndex) => currentIndex !== index)
    );
  };

  const validate = () => {
    const nextErrors = {};

    if (!form.product_name.trim()) {
      nextErrors.product_name = "Product name is required";
    }

    if (
      form.price === "" ||
      !Number.isFinite(Number(form.price)) ||
      Number(form.price) < 0
    ) {
      nextErrors.price = "Enter a valid selling price";
    }

    if (
      form.mrp !== "" &&
      (!Number.isFinite(Number(form.mrp)) || Number(form.mrp) < 0)
    ) {
      nextErrors.mrp = "Enter a valid MRP";
    }

    if (
      form.supplier_id &&
      (!Number.isSafeInteger(Number(form.supplier_id)) ||
        Number(form.supplier_id) <= 0)
    ) {
      nextErrors.supplier_id = "Select a valid supplier";
    }

    if (!variants.length) {
      nextErrors.variants = "Add at least one variant";
    }

    const seen = new Set();

    variants.forEach((variant, index) => {
      if (!String(variant.size || "").trim()) {
        nextErrors[`size_${index}`] = "Size is required";
      }

      if (!String(variant.color || "").trim()) {
        nextErrors[`color_${index}`] = "Color is required";
      }

      if (
        variant.qty === "" ||
        !Number.isInteger(Number(variant.qty)) ||
        Number(variant.qty) < 0
      ) {
        nextErrors[`qty_${index}`] = "Enter a valid whole quantity";
      }

      const key =
        `${String(variant.size).trim().toLowerCase()}|` +
        `${String(variant.color).trim().toLowerCase()}`;

      if (seen.has(key)) {
        nextErrors[`duplicate_${index}`] =
          "This size and color combination already exists";
      }

      seen.add(key);
    });

    setErrors(nextErrors);

    if (Object.keys(nextErrors).length) {
      toast.error("Please check the highlighted fields");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (saving || !validate()) return;

    setSaving(true);

    try {
      const body = new FormData();

      body.append("product_name", form.product_name.trim());
      body.append("description", form.description || "");
      body.append("product_category", form.product_category || "General");
      body.append("brand", form.brand || "");
      body.append("gender", form.gender || "Unisex");
      body.append("fabric", form.fabric || "");
      body.append("pattern", form.pattern || "Solid");
      body.append("price", String(Number(form.price)));
      body.append("mrp", form.mrp === "" ? "" : String(Number(form.mrp)));
      body.append("unit", form.unit || "pcs");
      body.append("branch", form.branch || "");
      body.append("supplier_id", form.supplier_id || "");
      body.append("hsn", form.hsn || "");

      const cleanedVariants = variants.map((variant) => ({
        size: String(variant.size).trim(),
        color: String(variant.color).trim(),
        qty: Number(variant.qty),
        sku: String(variant.sku || "").trim(),
      }));

      body.append("variants", JSON.stringify(cleanedVariants));

      images.forEach((file) => {
        body.append("images", file);
      });

      const response = await api.post("/GarmentsProduct/insertProduct", body);

      if (response.data?.success) {
        const result = response.data;
        toast.success(result.message || "Product added successfully");

        setForm(INITIAL_FORM);
        setVariants([{ ...INITIAL_VARIANT }]);
        setImages([]);
        setErrors({});

        navigate("/GarmentsProducts");
      } else {
        throw new Error(
          response.data?.message || "Product could not be saved"
        );
      }
    } catch (error) {
      console.error("Save garment product error:", error);
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to save product";
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  const totalStock = variants.reduce(
    (total, variant) => total + (Number(variant.qty) || 0),
    0
  );

  const money = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      maximumFractionDigits: 2,
    });

  return (
    <div className="min-h-screen bg-slate-50 pb-10">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex min-w-0 items-center gap-3">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-slate-200 text-slate-600 transition hover:bg-slate-100"
              aria-label="Go back"
            >
              <ArrowLeft size={19} />
            </button>

            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-600 text-white shadow-sm">
              <Shirt size={23} />
            </div>

            <div className="min-w-0">
              <h1 className="truncate text-lg font-extrabold text-slate-900 sm:text-2xl">
                Add Garments Product
              </h1>
              <p className="hidden text-sm text-slate-500 sm:block">
                Create a product with sizes, colors and stock
              </p>
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-3 pt-5 sm:px-6 sm:pt-8 lg:px-8">
        {/* Summary Cards */}
        <div className="mb-6 grid grid-cols-2 gap-3 lg:grid-cols-4">
          <div className="rounded-2xl border border-slate-200 bg-white p-4">
            <div className="flex items-center gap-2 text-xs font-medium text-slate-500">
              <Package size={16} className="text-indigo-600" />
              Product
            </div>
            <p className="mt-2 truncate text-sm font-bold text-slate-900">
              {form.product_name || "New product"}
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-4">
            <div className="flex items-center gap-2 text-xs font-medium text-slate-500">
              <Layers size={16} className="text-indigo-600" />
              Variants
            </div>
            <p className="mt-2 text-xl font-extrabold text-slate-900">
              {variants.length}
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-4">
            <div className="flex items-center gap-2 text-xs font-medium text-slate-500">
              <Package size={16} className="text-indigo-600" />
              Total Stock
            </div>
            <p className="mt-2 text-xl font-extrabold text-slate-900">
              {totalStock}
            </p>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-4">
            <div className="flex items-center gap-2 text-xs font-medium text-slate-500">
              <IndianRupee size={16} className="text-indigo-600" />
              Selling Price
            </div>
            <p className="mt-2 text-xl font-extrabold text-slate-900">
              ₹{money(form.price)}
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="grid grid-cols-1 items-start gap-5 xl:grid-cols-3">
            {/* Main form */}
            <div className="space-y-5 xl:col-span-2">
              {/* Basic information */}
              <section className={cardClass}>
                <SectionTitle
                  icon={Package}
                  title="Basic Information"
                  description="Enter the product name and general details."
                />

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <Field
                    label="Product Name"
                    required
                    className="sm:col-span-2"
                  >
                    <input
                      className={inputClass}
                      value={form.product_name}
                      onChange={(e) =>
                        updateForm("product_name", e.target.value)
                      }
                      placeholder="e.g. Premium Cotton Shirt"
                      maxLength={200}
                    />
                    {errors.product_name && (
                      <p className="mt-1 text-xs text-red-600">
                        {errors.product_name}
                      </p>
                    )}
                  </Field>

                  <Field label="Category" required>
                    <select
                      className={inputClass}
                      value={form.product_category}
                      onChange={(e) =>
                        updateForm("product_category", e.target.value)
                      }
                    >
                      {CATEGORIES.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Field>

                  <Field label="Brand">
                    <input
                      className={inputClass}
                      value={form.brand}
                      onChange={(e) => updateForm("brand", e.target.value)}
                      placeholder="Enter brand name"
                    />
                  </Field>

                  <Field label="Gender">
                    <select
                      className={inputClass}
                      value={form.gender}
                      onChange={(e) => updateForm("gender", e.target.value)}
                    >
                      {GENDERS.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Field>

                  <Field label="Fabric">
                    <select
                      className={inputClass}
                      value={form.fabric}
                      onChange={(e) => updateForm("fabric", e.target.value)}
                    >
                      <option value="">Select fabric</option>
                      {FABRICS.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Field>

                  <Field label="Pattern">
                    <select
                      className={inputClass}
                      value={form.pattern}
                      onChange={(e) => updateForm("pattern", e.target.value)}
                    >
                      {PATTERNS.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </Field>

                  <Field label="HSN Code">
                    <input
                      className={inputClass}
                      value={form.hsn}
                      onChange={(e) => updateForm("hsn", e.target.value)}
                      placeholder="Enter HSN code"
                      maxLength={30}
                    />
                  </Field>

                  <Field label="Unit">
                    <select
                      className={inputClass}
                      value={form.unit}
                      onChange={(e) => updateForm("unit", e.target.value)}
                    >
                      <option value="pcs">Pieces (pcs)</option>
                      <option value="set">Set</option>
                      <option value="pair">Pair</option>
                      <option value="pack">Pack</option>
                    </select>
                  </Field>

                  <Field label="Branch">
                    <input
                      className={inputClass}
                      value={form.branch}
                      onChange={(e) => updateForm("branch", e.target.value)}
                      placeholder="Branch name or ID"
                    />
                  </Field>

                  <Field label="Supplier">
                    <div className="flex gap-2">
                      <select
                        className={inputClass + " min-w-0 flex-1"}
                        value={form.supplier_id}
                        onChange={(e) =>
                          updateForm("supplier_id", e.target.value)
                        }
                        disabled={loadingSuppliers}
                      >
                        <option value="">
                          {loadingSuppliers
                            ? "Loading suppliers..."
                            : "Select supplier (optional)"}
                        </option>

                        {suppliers.map((supplier) => {
                          const id =
                            supplier.supplier_id ??
                            supplier.id ??
                            supplier.SupplierID;

                          const name =
                            supplier.supplier_name ??
                            supplier.name ??
                            supplier.company_name ??
                            supplier.SupplierName;

                          if (id == null || name == null) return null;

                          return (
                            <option key={id} value={id}>
                              {name}
                            </option>
                          );
                        })}
                      </select>

                      <button
                        type="button"
                        onClick={loadSuppliers}
                        className="mt-1.5 flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50"
                        title="Refresh suppliers"
                      >
                        <RefreshCw
                          size={17}
                          className={loadingSuppliers ? "animate-spin" : ""}
                        />
                      </button>
                    </div>
                  </Field>

                  <Field label="Description" className="sm:col-span-2">
                    <textarea
                      className={inputClass + " min-h-28 resize-y"}
                      value={form.description}
                      onChange={(e) =>
                        updateForm("description", e.target.value)
                      }
                      placeholder="Product description, material details..."
                      rows={4}
                    />
                  </Field>
                </div>
              </section>

              {/* Pricing */}
              <section className={cardClass}>
                <SectionTitle
                  icon={IndianRupee}
                  title="Pricing"
                  description="Set the selling price and maximum retail price."
                />

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <Field label="Selling Price (₹)" required>
                    <div className="relative">
                      <IndianRupee
                        size={16}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                      />
                      <input
                        className={inputClass + " pl-9"}
                        type="number"
                        min="0"
                        step="0.01"
                        value={form.price}
                        onChange={(e) => updateForm("price", e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                    {errors.price && (
                      <p className="mt-1 text-xs text-red-600">
                        {errors.price}
                      </p>
                    )}
                  </Field>

                  <Field label="MRP (₹)">
                    <div className="relative">
                      <IndianRupee
                        size={16}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
                      />
                      <input
                        className={inputClass + " pl-9"}
                        type="number"
                        min="0"
                        step="0.01"
                        value={form.mrp}
                        onChange={(e) => updateForm("mrp", e.target.value)}
                        placeholder="0.00"
                      />
                    </div>
                  </Field>
                </div>
              </section>

              {/* Variants */}
              <section className={cardClass}>
                <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
                  <SectionTitle
                    icon={Layers}
                    title="Size, Color & Stock"
                    description="Each size and color combination is saved as a separate variant."
                  />

                  <button
                    type="button"
                    onClick={addVariant}
                    className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-700"
                  >
                    <Plus size={17} />
                    Add Variant
                  </button>
                </div>

                {errors.variants && (
                  <p className="mb-3 text-sm text-red-600">{errors.variants}</p>
                )}

                <div className="space-y-4">
                  {variants.map((variant, index) => (
                    <div
                      key={index}
                      className="rounded-xl border border-slate-200 bg-slate-50 p-3 sm:p-4"
                    >
                      <div className="mb-3 flex items-center justify-between">
                        <p className="text-sm font-bold text-slate-800">
                          Variant {index + 1}
                        </p>

                        <button
                          type="button"
                          onClick={() => removeVariant(index)}
                          className="flex h-8 w-8 items-center justify-center rounded-lg text-red-500 transition hover:bg-red-50"
                          title="Remove variant"
                        >
                          <Trash2 size={17} />
                        </button>
                      </div>

                      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
                        <Field label="Size" required>
                          <select
                            className={inputClass}
                            value={variant.size}
                            onChange={(e) =>
                              updateVariant(index, "size", e.target.value)
                            }
                          >
                            {SIZES.map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                        </Field>

                        <Field label="Color" required>
                          <select
                            className={inputClass}
                            value={variant.color}
                            onChange={(e) =>
                              updateVariant(index, "color", e.target.value)
                            }
                          >
                            {COLORS.map((color) => (
                              <option key={color} value={color}>
                                {color}
                              </option>
                            ))}
                          </select>
                        </Field>

                        <Field label="Quantity" required>
                          <input
                            className={inputClass}
                            type="number"
                            min="0"
                            value={variant.qty}
                            onChange={(e) =>
                              updateVariant(index, "qty", e.target.value)
                            }
                            placeholder="0"
                          />
                        </Field>

                        <Field label="SKU (Optional)">
                          <input
                            className={inputClass}
                            value={variant.sku}
                            onChange={(e) =>
                              updateVariant(index, "sku", e.target.value)
                            }
                            placeholder="Auto-generated"
                          />
                        </Field>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            {/* Sidebar / Images & Actions */}
            <div className="space-y-5">
              <section className={cardClass}>
                <SectionTitle
                  icon={ImagePlus}
                  title="Product Images"
                  description="Upload up to 10 images. First image is primary."
                />

                <label className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 p-6 text-center cursor-pointer hover:bg-slate-100 transition">
                  <Upload size={24} className="text-slate-400 mb-2" />
                  <span className="text-sm font-semibold text-slate-700">
                    Click to upload images
                  </span>
                  <span className="text-xs text-slate-400 mt-1">
                    PNG, JPG, WEBP up to 5MB
                  </span>
                  <input
                    type="file"
                    multiple
                    accept="image/png, image/jpeg, image/webp, image/gif"
                    className="hidden"
                    onChange={handleImages}
                  />
                </label>

                {imagePreviews.length > 0 && (
                  <div className="mt-4 grid grid-cols-3 gap-2">
                    {imagePreviews.map((item, index) => (
                      <div
                        key={index}
                        className="relative aspect-square rounded-lg border border-slate-200 overflow-hidden bg-slate-100 group"
                      >
                        <img
                          src={item.url}
                          alt="Preview"
                          className="h-full w-full object-cover"
                        />
                        {index === 0 && (
                          <span className="absolute bottom-1 left-1 rounded bg-indigo-600 px-1.5 py-0.5 text-[10px] font-bold text-white">
                            Primary
                          </span>
                        )}
                        <button
                          type="button"
                          onClick={() => removeImage(index)}
                          className="absolute top-1 right-1 flex h-6 w-6 items-center justify-center rounded-full bg-red-600 text-white opacity-90 hover:opacity-100"
                        >
                          <X size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </section>

              {/* Save Button Card */}
              <section className={cardClass}>
                <button
                  type="submit"
                  disabled={saving}
                  className="w-full flex items-center justify-center gap-2 rounded-xl bg-indigo-600 px-4 py-3.5 text-sm font-bold text-white shadow-lg shadow-indigo-200 transition hover:bg-indigo-700 disabled:opacity-50"
                >
                  {saving ? (
                    <>
                      <LoaderCircle size={18} className="animate-spin" />
                      Saving Product...
                    </>
                  ) : (
                    <>
                      <Save size={18} />
                      Save Product & Inventory
                    </>
                  )}
                </button>
              </section>
            </div>
          </div>
        </form>
      </main>
    </div>
  );
}